export const SepelioDetalle = ({ data }) => {
    return (
        <>
            <div className="row px-2 pt-2 w-100" style={{ fontSize: "13px" }}>
                <div className="col-12">
                    <p style={{ fontWeight: 500 }}>
                        Detalles de Subsidiado/a:
                    </p>
                </div>
                <div className="col-3">
                    <span style={{ fontWeight: 500 }}>Nombre Completo</span>
                    <p>{data.nombreSubsidiado}</p>
                </div>
                <div className="col-3">
                    <span style={{ fontWeight: 500 }}>Cédula de Identidad</span>
                    <p>{data.cedulaSubsidiado}</p>
                </div>
                {
                    data.nroSocioSubsidiado &&
                    <div className="col-3">
                        <span style={{ fontWeight: 500 }}>Nro. de Socio</span>
                        <p>{data.nroSocioSubsidiado}</p>
                    </div>
                }
                <div className="col-3">
                    <span style={{ fontWeight: 500 }}>Relación con el Solicitante</span>
                    <p>{data.tipoVinculo}</p>
                </div>
            </div>
            <hr />
        </>
    )
}